var render = function render(){var _vm=this,_c=_vm._self._c;return _c('span',{staticClass:"key"},[(_vm.cap)?_c('img',{style:(_vm.cap.style),attrs:{"src":_vm.cap.src,"alt":_vm.letter}}):[_vm._v(_vm._s(_vm.letter))]],2)
}
var staticRenderFns = []

export { render, staticRenderFns }